import React, { useState, useEffect } from 'react';
import { Box, Button, Grid, Card, CardContent, Typography, Alert, CircularProgress } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import ModuleHub from '../components/ModuleHub';
import { getARDashboard } from '../../../services/api';

const ARDashboard = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => { loadData(); }, []);
  const loadData = async () => {
    try { setLoading(true); const r = await getARDashboard(); setData(r.data); }
    catch (err) { setError(err.message); } finally { setLoading(false); }
  };

  return (
    <ModuleHub moduleId="accounts-receivable" showFeatures={false}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Button startIcon={<RefreshIcon />} onClick={loadData}>Refresh</Button>
      </Box>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {loading ? <CircularProgress /> : data && (
        <Grid container spacing={2}>
          {[
            { label: 'Total Customers', value: data.totalCustomers, path: '/customers', color: '#16a34a' },
            { label: 'Total Invoices', value: data.totalInvoices, path: '/invoices', color: '#2563eb' },
            { label: 'Overdue Invoices', value: data.overdueInvoices, path: '/accounting/accounts-receivable/aging', color: '#dc2626' }
          ].map(c => (
            <Grid item xs={12} md={4} key={c.label}>
              <Card sx={{ cursor: 'pointer', borderLeft: `4px solid ${c.color}` }} onClick={() => navigate(c.path)}>
                <CardContent>
                  <Typography color="text.secondary">{c.label}</Typography>
                  <Typography variant="h4" fontWeight={700}>{c.value ?? 0}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
          <Grid item xs={12}>
            <Card><CardContent>
              <Typography variant="h6" gutterBottom>Quick Actions</Typography>
              <Button sx={{ mr: 1 }} variant="contained" onClick={() => navigate('/invoices/new')}>Create Invoice</Button>
              <Button sx={{ mr: 1 }} variant="outlined" onClick={() => navigate('/customers')}>Manage Customers</Button>
              <Button variant="outlined" onClick={() => navigate('/credit/payments')}>Collect Payment</Button>
            </CardContent></Card>
          </Grid>
        </Grid>
      )}
    </ModuleHub>
  );
};

export default ARDashboard;
